import { GraviChatButton } from '@/components/GraviChat/GraviChatButton'
import { ReferenceDataFilter } from '@/pages/Dashboard/panels/ReferenceDataPanel/components/ReferenceDataFilter'
import { Horizontal, NotificationSummaryButton } from '@gravitate-js/excalibrr'
import { useState } from 'react'
import {
  NotificationDrawer,
  type NotificationItem,
} from '../NotificationDrawer'

export const PageToolbarSlot = () => {
  const [visible, setVisible] = useState(false)
  const [notifications, setNotifications] = useState<NotificationItem[]>([])

  const showDrawer = () => {
    setVisible(true)
  }

  const onClose = () => {
    setVisible(false)
  }

  const isReferenceDataPage = window.location.pathname.includes(
    'integration-management/reference-data',
  )

  return (
    <>
      {isReferenceDataPage && (
        <Horizontal justifyContent='flex-end' className='overflow-visible pr-3'>
          <ReferenceDataFilter />
        </Horizontal>
      )}
      {/* Gravitate-only AI assistant. Renders null for non-Gravitate users. */}
      <GraviChatButton />
      <NotificationSummaryButton
        numNotifications={notifications.length}
        onClick={showDrawer}
      />
      <NotificationDrawer
        visible={visible}
        onClose={onClose}
        notifications={notifications}
        setNotifications={setNotifications}
      />
    </>
  )
}
